import React, { useContext } from 'react';
import { ThemeContext } from '../../../context/ThemeContext';
import Datamanager from '../DataManager/Datamanager';
const AppLayout = ({ title, children }) => {
    const {darkMode} =useContext(ThemeContext)
    return (
        <div style={{backgroundColor: darkMode ? 'var(--background-color)' : 'var(--white)'}}>
            {children}
        </div>
    );
};

export default AppLayout;
